import { useMemo } from 'react';

import { usePublicWorkspace } from '~/components/PublicWorkspaceProvider';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';

export const usePublicWhiteLabel = () => {
  const { whiteLabelWorkspaces } = useFeatureFlags();
  const { workspaceId } = usePublicWorkspace();

  return useMemo(
    () => ({
      isWhiteLabel: whiteLabelWorkspaces?.includes(workspaceId),
    }),
    [whiteLabelWorkspaces, workspaceId],
  );
};
